import { Radar } from "lucide-react";
import { useGuardiaStore } from "../../store/guardiaStore";

// Overlay con el estado de la Guardia Virtual. Es el unico que se suscribe a la
// cuenta regresiva, asi el re-render por segundo queda confinado aca.
export function GuardiaBadge() {
  const running = useGuardiaStore((s) => s.running);
  const cycleIndex = useGuardiaStore((s) => s.cycleIndex);
  const totalCycles = useGuardiaStore((s) => s.totalCycles);
  const remainingSec = useGuardiaStore((s) => s.remainingSec);
  const paused = useGuardiaStore((s) => s.paused);
  const verifying = useGuardiaStore((s) => s.verifying);
  const emptyReason = useGuardiaStore((s) => s.emptyReason);

  if (!running) return null;

  let detail: string;
  if (emptyReason === "no-cameras") detail = "Sin camaras disponibles";
  else if (emptyReason === "all-offline") detail = "Todos los equipos offline";
  else if (verifying) detail = "Verificando equipos...";
  else detail = `Ciclo ${cycleIndex}/${totalCycles} · ${remainingSec}s`;

  return (
    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-30 pointer-events-none flex items-center gap-2 rounded-full bg-black/75 px-3 py-1 text-xs text-white shadow-lg">
      <Radar size={13} className={paused ? "" : "animate-pulse"} />
      <span className="font-medium">Guardia Virtual</span>
      <span className="text-white/60">{"·"}</span>
      <span>{detail}</span>
      {paused && (
        <span className="ml-1 rounded bg-amber-500/90 px-1.5 py-0.5 text-[10px] font-semibold text-black">
          Pausado
        </span>
      )}
    </div>
  );
}
